import { useEffect } from 'react';
import { connect } from 'react-redux';
import { MessageBarType, Pivot, PivotItem, Spinner } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

// components
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import { HeaderPersonaComponent } from '../../../commons/component/headers/HeaderPersona/HeaderPersonaComponent';
import { MessageComponent } from '../../../commons/component/MessageComponent';
import { withRouter } from '../../../commons/component/withRouterCustom';
import PersonResumeComponent from '../../../components/Persons/PersonForm/Person.Resume.Component';
import PersonIdentifiersListComponent from '../../../components/Persons/PersonIdentifiers/PersonIdentifiers.List.Component';
import PersonPhonesListComponent from '../../../components/Persons/PersonPhones/PersonPhones.List.Component';
import PersonEmailsListComponent from '../../../components/Persons/PersonEmails/PersonEmails.List.Component';
import PersonAddressesListComponent from '../../../components/Persons/PersonAddresses/PersonAddresses.List.Component';
import PersonRelationshipsListComponent from '../../../components/Persons/PersonRelationships/PersonRelationships.List.Component';
import PersonExternalAssociationsListComponent from '../../../components/Persons/PersonExternalAssociations/PersonExternalAssociations.List.Component';

// functions
import * as CommonFunctions from '../../../components/Persons/Persons.Functions';
import * as ownFunctions from './Staff.Details.Page.Functions';

export const StaffDetailsPage = (props: ownFunctions.Props) => {
  //useTranslation()
  const [t] = useTranslation();

  useEffect(() => {
    if (props.PersonId && props.Person?.id === undefined) {
      props.GetPersonById(props.PersonId);
    }
  }, [props.PersonId, props.Person?.id]);

  return (
    <>
      <PageHeader title={t('staffDetailsPage.title', { defaultValue: 'Ficha del miembro del staff' })} />
      <div className="Content">
        {props.failOnLoadingPerson && (
          <div className="Section">
            <MessageComponent
              message={t('staffDetailsPage.error', {
                defaultValue: 'No fue posible obtener los datos del miembro del staff'
              })}
              subMessage={props.error?.ErrorMessage || ''}
              type={MessageBarType.error}
              itemList={props.error?.Errors || []}
            />
          </div>
        )}

        {props.isPersonLoading && !props.Person && (
          <div className="Section">
            <Spinner
              label={t('staffDetailsPage.loading', { defaultValue: 'Cargando ficha...' })}
              ariaLive="assertive"
              labelPosition="top"
            />
          </div>
        )}

        {props.Person && (
          <>
            <div className="Section">
              <HeaderPersonaComponent
                PersonaName={CommonFunctions.GetPersonDisplayName(props.Person)}
                secondaryText={
                  props.Person.activity ||
                  t('staffDetailsPage.subtitle', { defaultValue: 'Miembro del staff' })
                }
              />
            </div>
            <div className="Section">
              <Pivot>
                <PivotItem headerText={t('staffDetailsPage.tabs.personalData', { defaultValue: 'Datos personales' })}>
                  <PersonResumeComponent Person={props.Person} />
                </PivotItem>
                <PivotItem headerText={t('staffDetailsPage.tabs.identifiers', { defaultValue: 'Identificaciones' })}>
                  <PersonIdentifiersListComponent
                    PersonId={props.Person.id}
                    PersonType={props.Person.personType}
                  />
                </PivotItem>
                <PivotItem headerText={t('staffDetailsPage.tabs.phones', { defaultValue: 'Teléfonos' })}>
                  <PersonPhonesListComponent PersonId={props.Person.id} />
                </PivotItem>
                <PivotItem headerText={t('staffDetailsPage.tabs.emails', { defaultValue: 'Correos' })}>
                  <PersonEmailsListComponent PersonId={props.Person.id} />
                </PivotItem>
                <PivotItem headerText={t('staffDetailsPage.tabs.addresses', { defaultValue: 'Domicilios' })}>
                  <PersonAddressesListComponent PersonId={props.Person.id} />
                </PivotItem>
                <PivotItem headerText={t('staffDetailsPage.tabs.relationships', { defaultValue: 'Relaciones' })}>
                  <PersonRelationshipsListComponent
                    PersonId={props.Person.id}
                    PersonType={props.Person.personType}
                  />
                </PivotItem>
                <PivotItem
                  headerText={t('staffDetailsPage.tabs.externalAssociations', {
                    defaultValue: 'Asociaciones externas'
                  })}
                >
                  <PersonExternalAssociationsListComponent PersonId={props.Person.id} />
                </PivotItem>
              </Pivot>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default withRouter(
  connect(ownFunctions.mapStateToProps, ownFunctions.mapDispatchToProps)(StaffDetailsPage as any)
);
